// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items-feed[data-v-186f3fdf]{margin-top:-20px}\n", ""]);
// Exports
module.exports = exports;
